import React from 'react';
import { HomeDashboard } from '../components/home/homeDashboard';
import { Header } from '../components/global/header';
import { Footer } from '../components/global/footer';

export function HomeDashboardPage() {
  return (
    <div>
      <Header />
      <HomeDashboard />
      <Footer />
    </div>
  );
}

export default HomeDashboardPage;
